export default {
  challengesLoaded(state) {
    return state.challengesLoaded;
  },
  challenges(state) {
    return state.challenges;
  },
  submissions(state) {
    return state.submissions;
  },
};
